// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Faa-z","subtitle":"Gaa-z","wrapper":"Haa-z","leftArrow":"Iaa-z","rightArrow":"Jaa-z"};